import { MenuItem, TextField, Typography } from '@mui/material';
import React, { memo, useCallback } from "react";
import PropTypes from 'prop-types';
import { StyleLine } from '../../../types';

const SelectDefaultEdgeShape = memo(function SelectDefaultEdgeShape({
  hideLabel = false,
  name,
  defaultValue,
  value,
  handleChange,
  ...props
}) {
  const handleStyleEdgeChange = useCallback((event) => {
    handleChange({
      target: {
        name,
        value: event.target.value
      }
    });
  }, [name, handleChange]);

  return (
    <div>
      {!hideLabel && (
        <Typography variant="caption">
          Default style preferences for edges.
        </Typography>
      )}
      <TextField 
        id="template-style-shape" 
        select 
        label="Edge style" 
        size="small" 
        margin="dense" 
        defaultValue={defaultValue} 
        value={value} 
        onChange={handleStyleEdgeChange} 
        sx={{ width: "100%" }}
        {...props}
      >
        {StyleLine.map((option) => (
          <MenuItem key={option.value} value={option.value}>
            {option.label}
          </MenuItem>
        ))}
      </TextField>
    </div>
  );
});

SelectDefaultEdgeShape.propTypes = {
  hideLabel: PropTypes.bool,
  name: PropTypes.string.isRequired,
  defaultValue: PropTypes.string,
  value: PropTypes.string,
  handleChange: PropTypes.func.isRequired,
};

export default SelectDefaultEdgeShape;